import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState(['screenWidth']),

        isTablet () {
            return this.screenWidth > 768
        },

        isMobile () {
            return this.screenWidth <= 768
        }
    }
}
